import { get } from 'lodash';

import FilterDefinition from 'helpers/search_filters/filter_definition';
import EnumFormatter from '../../search_filters/formatters/enum_formatter';
import MeasurementFormatter from 'helpers/search_filters/formatters/measurement_formatter';

const buildSelector = path => query => get(query, `industrialFilter.${path}`);

export const acresStabilized = new FilterDefinition({
  label: 'Acres Stabilized',
  type: FilterDefinition.types.range,
  minValue: buildSelector('minAcresStabilized'),
  maxValue: buildSelector('maxAcresStabilized')
});

export const availableRailProvider = new FilterDefinition({
  label: 'Available Rail Provider',
  formatter: new EnumFormatter({ 1: 'UP', 2: 'BNSF', 3: 'KCS', 4: 'Dual' }),
  value: buildSelector('availableRailProvider')
});

export const bridgeCraneSpan = new FilterDefinition({
  label: 'Bridge Crane Span',
  formatter: new MeasurementFormatter(),
  type: FilterDefinition.types.range,
  minValue: buildSelector('minBridgeCraneSpan'),
  maxValue: buildSelector('maxBridgeCraneSpan'),
  unit: 'f'
});

export const driveThroughAccess = new FilterDefinition({
  label: 'Building Drive Through Access',
  type: FilterDefinition.types.boolean,
  value: buildSelector('driveThroughAccess')
});

export const jibCraneSpan = new FilterDefinition({
  label: 'Jib Crane Span',
  formatter: new MeasurementFormatter(),
  type: FilterDefinition.types.range,
  minValue: buildSelector('minJibCraneSpan'),
  maxValue: buildSelector('maxJibCraneSpan'),
  unit: 'f'
});

export const lotBorderType = new FilterDefinition({
  label: 'Lot Border Type',
  formatter: new EnumFormatter({ 0: 'Fenced', 1: 'Secured' }),
  value: buildSelector('lotBorderType')
});

export const lotStabilization = new FilterDefinition({
  label: 'Lot Stabilization',
  formatter: new EnumFormatter({ 0: 'Stabilized', 1: 'Concrete' }),
  value: buildSelector('lotStabilization')
});

export const numBridgeCranes = new FilterDefinition({
  label: 'Number of Bridge Cranes',
  type: FilterDefinition.types.range,
  minValue: buildSelector('minNumBridgeCranes'),
  maxValue: buildSelector('maxNumBridgeCranes')
});

export const numJibCranes = new FilterDefinition({
  label: 'Number of Jib Cranes',
  type: FilterDefinition.types.range,
  minValue: buildSelector('minNumJibCranes'),
  maxValue: buildSelector('maxNumJibCranes')
});

export const ready = new FilterDefinition({
  label: 'Ready',
  type: FilterDefinition.types.boolean,
  value: buildSelector('ready')
});

export const readyCapacity = new FilterDefinition({
  label: 'Ready Capacity',
  formatter: new MeasurementFormatter(),
  type: FilterDefinition.types.range,
  minValue: buildSelector('minReadyCapacity'),
  maxValue: buildSelector('maxReadyCapacity'),
  unit: 'tons'
});

export const readySpan = new FilterDefinition({
  label: 'Ready Span',
  formatter: new MeasurementFormatter(),
  type: FilterDefinition.types.range,
  minValue: buildSelector('minReadySpan'),
  maxValue: buildSelector('maxReadySpan'),
  unit: 'f'
});

export const served = new FilterDefinition({
  label: 'Served',
  type: FilterDefinition.types.boolean,
  value: buildSelector('served')
});

export const servedRailProvider = new FilterDefinition({
  label: "Served Rail Provider",
  formatter: new EnumFormatter({ 1: 'UP', 2: 'BNSF', 3: 'KCS', 4: 'Dual' }),
  value: buildSelector('servedRailProvider')
});

export default [
  acresStabilized,
  availableRailProvider,
  bridgeCraneSpan,
  driveThroughAccess,
  jibCraneSpan,
  lotBorderType,
  lotStabilization,
  numBridgeCranes,
  numJibCranes,
  ready,
  readyCapacity,
  readySpan,
  served,
  servedRailProvider
];
